import { render } from "./HandbookArticleModal.vue?vue&type=template&id=f59f216a&scoped=true"
import script from "./HandbookArticleModal.vue?vue&type=script&lang=js"
export * from "./HandbookArticleModal.vue?vue&type=script&lang=js"

import "./HandbookArticleModal.vue?vue&type=style&index=0&id=f59f216a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59f216a"]])

export default __exports__